module.exports = __webpack_public_path__ + "img/behold-4.c15c2ef8.png";